import axios from "axios";

function hasMissingRateMessage(payload) {
    const serverMessages = payload?._server_messages;
    if (!serverMessages) return false;

    try {
        const parsedMessages = JSON.parse(serverMessages);
        return parsedMessages.some((rawMessage) => {
            try {
                const message = JSON.parse(rawMessage);
                return String(message?.message || "").includes(
                    "Unable to find exchange rate"
                );
            } catch (error) {
                return String(rawMessage || "").includes(
                    "Unable to find exchange rate"
                );
            }
        });
    } catch (error) {
        return String(serverMessages || "").includes("Unable to find exchange rate");
    }
}

export async function fetchExchangeRateWithFallback(
    fromCurrency,
    toCurrency
) {
    const normalizedFrom = String(fromCurrency || "")
        .trim()
        .toUpperCase();
    const normalizedTo = String(toCurrency || "")
        .trim()
        .toUpperCase();

    if (!normalizedFrom || !normalizedTo) {
        throw new Error("Both fromCurrency and toCurrency are required");
    }

    if (normalizedFrom === normalizedTo) {
        return 1;
    }

    let primaryError = null;

    try {
        const response = await axios.get(
            "method/erpnext.setup.utils.get_exchange_rate",
            {
                params: {
                    from_currency: normalizedFrom,
                    to_currency: normalizedTo,
                },
            }
        );
        const rate = Number(response?.data?.message);
        if (rate > 0 && !hasMissingRateMessage(response?.data)) {
            return rate;
        }
    } catch (error) {
        primaryError = error;
    }

    const fallbackResponse = await fetch(
        `https://api.exchangerate-api.com/v4/latest/${normalizedFrom}`
    );
    if (!fallbackResponse.ok) {
        throw (
            primaryError ||
            new Error(
                `Failed to fetch exchange rate for ${normalizedFrom} -> ${normalizedTo}`
            )
        );
    }

    const fallbackData = await fallbackResponse.json();
    const fallbackRate = Number(fallbackData?.rates?.[normalizedTo]);

    if (fallbackRate > 0) {
        return fallbackRate;
    }

    throw (
        primaryError ||
        new Error(
            `Exchange rate not found for ${normalizedFrom} -> ${normalizedTo}`
        )
    );
}
